/**
 * Types para Login y Logout
 */

export const AUTH_TYPES = {
  LOGIN: '[auth] LOGIN',
  LOGOUT: '[auth] LOGOUT'
};
